import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "card-container inspection" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = {
  key: 0,
  class: "customer"
}
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "wo-details" }
const _hoisted_7 = { class: "customer" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Customer:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", null, "Vehicle:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", null, "Plate:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "Odometer:", -1)
const _hoisted_12 = {
  key: 0,
  class: "updateinspection"
}
const _hoisted_13 = { class: "header row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Item")
], -1)
const _hoisted_15 = { class: "resultGroup" }
const _hoisted_16 = {
  key: 0,
  class: "pi pi-fw pi-sort-alt"
}
const _hoisted_17 = {
  key: 1,
  class: "pi pi-fw pi-sort-amount-up-alt"
}
const _hoisted_18 = {
  key: 2,
  class: "pi pi-fw pi-sort-amount-down"
}
const _hoisted_19 = { class: "allOk" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "row",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_22 = { class: "title" }
const _hoisted_23 = {
  key: 1,
  class: "row",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_24 = { class: "title" }
const _hoisted_25 = {
  key: 0,
  class: "customer-badge flag"
}
const _hoisted_26 = {
  key: 1,
  class: "customer-badge flag"
}
const _hoisted_27 = {
  key: 2,
  class: "customer-badge flag"
}
const _hoisted_28 = {
  key: 0,
  class: "result"
}
const _hoisted_29 = {
  key: 1,
  class: "result"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "customer-badge status-null" }, "+", -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "allOk" }, null, -1)
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-times" }, null, -1)
const _hoisted_35 = { class: "prenex" }
const _hoisted_36 = {
  key: 0,
  class: "mt-3 mb-0"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("strong", null, "Values:", -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 1,
  class: "sub-fields"
}
const _hoisted_40 = { class: "row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "LF" }, "LF", -1)
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { for: "RF" }, "RF", -1)
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "units" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("strong", null, "Unit: ", -1)
const _hoisted_47 = { class: "row" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "LR" }, "LR", -1)
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { for: "RR" }, "RR", -1)
const _hoisted_51 = { key: 0 }
const _hoisted_52 = {
  key: 2,
  class: "mt-3 mb-0"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("strong", null, "Context:", -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = {
  key: 4,
  class: "mt-3 mb-0"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("strong", null, "Context:", -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3 mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Notes:")
], -1)
const _hoisted_59 = { style: {"float":"right","padding":"0.1rem 0 0 0","font-size":"0.875rem"} }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3 mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Internal Notes"),
  /*#__PURE__*/_createTextVNode(" (Not shown to customer(s)):")
], -1)
const _hoisted_61 = { style: {"float":"right","padding":"0.1rem 0 0 0","font-size":"0.875rem"} }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3 mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Reference Images:")
], -1)
const _hoisted_63 = {
  class: "reference",
  style: {"border":"1px solid #ccc","position":"relative"}
}
const _hoisted_64 = { style: {"list-style-type":"none","padding":"0","margin":"0"} }
const _hoisted_65 = ["onLoad"]
const _hoisted_66 = /*#__PURE__*/_createTextVNode("X")
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", { class: "mt-3 mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Reference Videos:")
], -1)
const _hoisted_68 = {
  class: "reference",
  style: {"border":"1px solid #ccc","position":"relative"}
}
const _hoisted_69 = { style: {"list-style-type":"none","padding":"0","margin":"0"} }
const _hoisted_70 = ["onLoad"]
const _hoisted_71 = /*#__PURE__*/_createTextVNode("X")
const _hoisted_72 = { style: {"display":"flex","align-items":"center","justify-content":"space-between","margin-top":"2rem","margin-bottom":"0"} }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Upload Images/Video:")
], -1)
const _hoisted_74 = {
  key: 0,
  class: "p-fileupload p-fileupload-advanced p-component"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("p", { style: {"background-color":"#f1f0ef","padding":"1.5rem 4rem","border-radius":"5px","text-align":"center","font-sie":"1rem"} }, " Maximum limit reached for image uploads ", -1)
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = {
  key: 1,
  class: "p-fileupload p-fileupload-advanced p-component"
}
const _hoisted_78 = { class: "p-fileupload-buttonbar" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "p-button-label" }, "Upload", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "p-ink" }, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", { class: "p-button-label" }, "Cancel", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("span", { class: "p-ink" }, null, -1)
const _hoisted_83 = {
  key: 0,
  class: "p-fileupload p-fileupload-advanced p-component"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("p", { style: {"background-color":"#f1f0ef","padding":"1.5rem 4rem","border-radius":"5px","text-align":"center","font-sie":"1rem"} }, " Maximum limit reached for video uploads ", -1)
const _hoisted_85 = [
  _hoisted_84
]
const _hoisted_86 = {
  key: 1,
  class: "p-fileupload p-fileupload-advanced p-component"
}
const _hoisted_87 = { class: "p-fileupload-buttonbar" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("span", { class: "p-button-label" }, "Upload", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "p-ink" }, null, -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "p-button-label" }, "Cancel", -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("span", { class: "p-ink" }, null, -1)
const _hoisted_92 = { class: "confirm" }
const _hoisted_93 = {
  key: 0,
  class: "overlay"
}
const _hoisted_94 = { class: "overlay-toolbar" }
const _hoisted_95 = { class: "tools" }
const _hoisted_96 = { class: "colours" }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = { class: "icons" }
const _hoisted_99 = { class: "edittools" }
const _hoisted_100 = ["onClick"]
const _hoisted_101 = { class: "managetools" }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = { class: "editor-container" }
const _hoisted_104 = {
  key: 1,
  class: "container flex-grow-1"
}

import { computed, onMounted, watch } from 'vue';
import { ref } from "@vue/reactivity";
import { WorkOrderPackage } from '../store/state';
import { useRouter } from 'vue-router';
import { useAuth0 } from "@auth0/auth0-vue";
import { MutationTypes } from "../store/mutations";
import { useStore } from "../store";
import { useVuelidate } from '@vuelidate/core';
import { helpers } from '@vuelidate/validators';
import { useToast } from 'primevue/usetoast';
import * as _ from "lodash";
import { useConfirm } from "primevue/useconfirm";
import ErrorModal from './ErrorModal.vue';
import { openErrorModal } from '@/composables/useErrorLog';

// Import FilePond
import vueFilePond from 'vue-filepond';

// Import plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginMediaPreview from 'filepond-plugin-media-preview';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';

// Import styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond-plugin-media-preview/dist/filepond-plugin-media-preview.min.css';

//image editor
import VueFeather from "vue-feather";
import Editor from "vue-image-markup";
import Dropdown from 'primevue/dropdown';

// image editor State

export default /*#__PURE__*/_defineComponent({
  name: 'DVIUpdateWorkOrderPackage',
  setup(__props) {

const canvasWidth = ref(500);
const canvasHeight = ref(500);
// const stateCrop = ref(true);
const file = ref("");
const editor = ref(null);
// const fileInput = ref(null);

const androidInfo = ref({
    isAndroid: false,
    version: 0,
})

const getAndroidInfo = async () => {
    const ua = navigator.userAgent || ''
    const match = ua.match(/Android\s([0-9.]+)/i)

    if (match && navigator.userAgentData?.getHighEntropyValues) {
      try {
        const data = await navigator.userAgentData.getHighEntropyValues(["platformVersion"])
        if (data.platformVersion) {
          androidInfo.value.isAndroid = true;
          androidInfo.value.version = parseFloat(data.platformVersion);
        }
      } catch (err) {
        console.warn("Could not get real Android version:", err)
      }
    }
}

const isCaptureOn = ref(false);

watch(isCaptureOn, (newVal) => {
  if (imagepond.value[0]) {
    imagepond.value[0]._pond.setOptions({
      ...imageServerOptions,
      captureMethod: newVal ? 'camera' : null
    });
  }

  if (videopond.value[0]) {
    videopond.value[0]._pond.setOptions({
        ...videoServerOptions,
        captureMethod: newVal ? 'camera' : null
    });
  }
});

const selectedColor = ref('#ffff00');

// Editor methods
const undo = () => { 
    if (editor.value.canvas._objects.length > 0) {
        editor.value?.undo();
    }
};
const redo = () => { 
    editor.value?.redo();
};
const deleteEditable = () => { 
    editor.value.canvas.getObjects().forEach(obj => {
        editor.value.canvas.remove(obj);
    });
};
const freeDrawing = () => { editor.value?.set("freeDrawing", { stroke: selectedColor.value, strokeWidth: 5 }); }
const addText = () => editor.value?.set("text", { fill: selectedColor.value, fontSize: 20, placeholder: "Type something" });
const addCicle = () => editor.value?.set("circle", { stroke: selectedColor.value, strokeWidth: 5 });
const addSquare = () => editor.value?.set("rect", { fill: selectedColor.value, stroke: selectedColor.value, strokeWidth: 1 });
const addArrow = () => editor.value?.set("arrow", { stroke: selectedColor.value, strokeWidth: 4 });
const drag = () => {
  editor.value.set("selectMode");
  editor.value?.canvas.getObjects().forEach(obj => lockScaleAndRotate(obj));
};

const lockScaleAndRotate = (obj) => {
    obj.hasControls = true;     // show handles if you want, or false
    obj.lockScalingX = true;    // prevent resizing X
    obj.lockScalingY = true;    // prevent resizing Y
    obj.lockRotation = true;    // prevent rotation
    obj.selectable = true;      // allow selection/moving
    obj.evented = true;         // keep events enabled
};

const updateColor = (color) => {
    selectedColor.value = color;

    if (selectedTool.value !== '') {
        const tools = [...managetools, ...edittools]; 
        const tool = tools.find(item => selectedTool.value === item.name);
        selectTool(tool?.name, tool?.action);
    }
}

const selectTool = (toolName, toolAction) => {
    // special case, selected tool addText and adding place holder
    // then suddenly changing to other tool causing fabric js error toLowerCase
    if (toolName === 'addText') {
        if (editor.value.canvas._iTextInstances) {
            editor.value.canvas._activeObject = null;
        }
        selectedTool.value = toolName;
    }

    const exemptedTools = ['undo', 'redo', 'saveImg', 'deleteEditable'];
    if (exemptedTools.includes(toolName)) {
        selectedTool.value = '';
        editor.value?.set("selectMode");
    } else {
        selectedTool.value = toolName;
    }
    
    toolAction();
}

const closeImageAnnotation = () => {
    imageeditorvisible.value = false;
    selectedColor.value = '#ffff00';
    selectedTool.value = '';
};

// const crop = () => {
//   editor.value?.set("crop", { width: 50, height: 100, overlayOpacity: 0.9 });
//   stateCrop.value = false;
// };

// const applyCrop = () => {
//   editor.value?.applyCropping();
//   stateCrop.value = true;
// };

// const uploadImg = (event) => editor.value?.uploadImage(event);

const saveImg = () => {
    const base64 = editor.value?.saveImage();
    if (!base64) return;

    file.value = base64;
    imagepond.value[0]._pond.addFile(base64).then(() => {
        imageeditorvisible.value = false;
    });
};

const selectedTool = ref('')
const colors = ['#000000', '#ff0000', '#0000ff', '#00ff00', '#ffff00', '#ffffff']
const edittools = [
  { action: freeDrawing, name: 'freeDrawing', icon: 'pen-tool' },
  { action: addText, name: 'addText', icon: 'type' },
  { action: addCicle, name: 'addCicle', icon: 'circle' },
  { action: addSquare, name: 'addSquare', icon: 'square' },
  { action: addArrow, name: 'addArrow', icon: 'mouse-pointer' }
]
const managetools = [
  { action: undo, name: 'undo', icon: 'corner-up-left' },
  { action: redo, name: 'redo', icon: 'corner-up-right' },
  { action: drag, name: 'drag', icon: 'move' },
  { action: deleteEditable, name: 'deleteEditable', icon: 'x-square' },
  { action: saveImg, name: 'saveImg', icon: 'save' }
]

const confirm = useConfirm();
const auth0 = useAuth0();
const router = useRouter();
const toast = useToast();
const workorderpackageid = computed(() => store.state.currentWorkOrderPackageID);
const workorderpackageheader = computed(() => store.state.currentWorkOrderPackageHeader);
const workorderid = ref('');
const workordernumber = ref('');
const lastname = ref('');
const firstname = ref('');
const make = ref('');
const model = ref('');
const color = ref('');
const plate = ref('');
const usage = ref();
const UsageComputed = computed(() => new Intl.NumberFormat().format(usage.value));
const PreviousButtonDisableStatus = ref(false);
const NextButtonDisableStatus = ref(false);
const currentInspectionLineIndex = ref();
const currentWorkOrderPackageInspectionLineID = ref();
const InspectionLinesLength = ref(0);
const showResultIcon = ref(false);
let currentWorkOrderPackage: WorkOrderPackage[] | undefined = [];
const currentWorkOrderPackageInspectionLinesRef = ref();
const dummyPostUrl = ref('');
dummyPostUrl.value = process.env.VUE_APP_NODEJS_BASE_URL + '/stores/test';

const suggestItem = ref([
    '1 - Part Is Close To The End Of Its Useful Life',
    '2 - To Address A Customer Need, Convenience Or Request',
    '3 - To Comply With Maintenance Recommended By The Vehicle\'s Original Equipment Manufacture',
    '4 - Technician\'s Recommendation Based on Substantial And Informed Experience',
    '5 - To Comply With Maintenance Recommended By AMRA/MAP'
]);

const RequiredItem = ref([
    'A - Part No Longer Performs Intended Purpose',
    'B - Part Does Not Meet A Design Specification (Regardless Of Performance)',
    'C - Part Is Missing'
]);


const status = ref(['OK', 'Suggested', 'Required']);
 const unit1 = ref([
    { UnitText: 'psi', Unit: 'PSI' },
    { UnitText: 'bar', Unit: 'BAR' }

 ]);
 const unit2 = ref([
    { UnitText: '/32"', Unit: 'NDS' },
    { UnitText: 'mm', Unit: 'Millimeter' }

]);

const LF = ref('');
const RF = ref('');
const LR = ref('');
const RR = ref('');

/**
 * Custom validation to check if value is empty string
 * @param value
 */
const valueIsRequired = (value) => {
    if (value !== '') {
        return true;
    }

    return false;
}

/**
 * Custom validation to check if number is valid
 * @param value 
 */
const isValidNumber = (value) => {
    if (value === '') {
        return true;
    }

    return !isNaN(value);
}

/**
 * Custom validation to check if number is 1 decimal place only
 * @param value 
 */
const decimalWithOneDecimalPlaceOrInteger = (value) => {
    if (value === '') {
        return true;
    }

    return /^\d+(\.\d)?$/.test(value); // allow whole or number with 1 decimal only, returns true if valid, and false if invalid
}

/**
 * Rules for vuelidate function
 */
const rules = computed(() => ({
  LF: {
    valueIsRequired: helpers.withMessage('Required', valueIsRequired),
    isValidNumber: helpers.withMessage('Number only', isValidNumber),
    decimalWithOneDecimalPlaceOrInteger: helpers.withMessage('max 1 decimal', decimalWithOneDecimalPlaceOrInteger)
  },
  RF: {
    valueIsRequired: helpers.withMessage('Required', valueIsRequired),
    isValidNumber: helpers.withMessage('Number only', isValidNumber),
    decimalWithOneDecimalPlaceOrInteger: helpers.withMessage('max 1 decimal', decimalWithOneDecimalPlaceOrInteger)
  },
  LR: {
    valueIsRequired: helpers.withMessage('Required', valueIsRequired),
    isValidNumber: helpers.withMessage('Number only', isValidNumber),
    decimalWithOneDecimalPlaceOrInteger: helpers.withMessage('max 1 decimal', decimalWithOneDecimalPlaceOrInteger)
  },
  RR: {
    valueIsRequired: helpers.withMessage('Required', valueIsRequired),
    isValidNumber: helpers.withMessage('Number only', isValidNumber),
    decimalWithOneDecimalPlaceOrInteger: helpers.withMessage('max 1 decimal', decimalWithOneDecimalPlaceOrInteger)
  },
}));

const v$ = useVuelidate(rules, { LF, RF, LR, RR });
const store = useStore();
const videoMaxCount = process.env.VUE_APP_VIDEO_MAX_COUNT;
const imageMaxCount = process.env.VUE_APP_IMAGE_MAX_COUNT;
const selectedImages = ref([]);
const selectedVideos = ref([]);
const videopond = ref(null);
const videoUploadCount = ref(0);
const currentVideoUploadCount = ref(0);
const imagepond = ref(null);
const imageUploadCount = ref(0);
const currentImageUploadCount = ref(0);
const imageLoaded = ref([]);
const Username = ref('');
const sortResult = ref('');
const currentDVIWO = computed(() => store.state.currentdviwoitem);
const empty = ref(false);

const imageeditorvisible = ref(false);
const inspectionnotes = ref<string[]>([]);
const selectedInspectionNote = ref('');
const noteplaceholder = ref('Select a note');

/**
 * Call load work order package and work order function in order to populate WO items
 */
onMounted(async () => {

    await getAndroidInfo();
    window.addEventListener('scroll', handleScroll);

    inspectionnotes.value = store.state.inspectionnotes;
    Username.value = store.state.username;

    if (currentDVIWO.value !== undefined) {
        workorderid.value = currentDVIWO.value?.WorkOrderID;
        workordernumber.value = currentDVIWO.value?.WorkOrderNumber.toString();
        lastname.value = currentDVIWO.value?.LastName;
        firstname.value = currentDVIWO.value?.FirstName;
        make.value = currentDVIWO.value?.Make;
        model.value = currentDVIWO.value?.Model;
        color.value = currentDVIWO.value?.Color;
        plate.value = currentDVIWO.value?.Plate;
        usage.value = currentDVIWO.value?.InUsage;
    }

    currentWorkOrderPackage = currentDVIWO.value?.WorkOrderPackages?.filter(obj => obj.WorkOrderPackageID === workorderpackageid.value);

    if (currentWorkOrderPackage !== undefined) {
        const WorkOrderPackageInspectionLines = _.cloneDeep(currentWorkOrderPackage[0].WorkOrderPackageInspectionLines);
        currentWorkOrderPackageInspectionLinesRef.value = WorkOrderPackageInspectionLines;
        InspectionLinesLength.value = WorkOrderPackageInspectionLines.length;
    } else {
        currentWorkOrderPackageInspectionLinesRef.value = [];
    }

    if (currentWorkOrderPackageInspectionLinesRef.value.length === 0) {
        empty.value = true;
    }

    showResultIcon.value = !currentWorkOrderPackageInspectionLinesRef.value
        .filter((item) => item.Type === 'Line')
        .every((item) => item.Result.trim() !== '');
});

/**
 * To display tob button
 */
const handleScroll = () => {
    const topButton = document.getElementById("topBtn");
    if (topButton) {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            topButton.style.display = "flex";
        } else {
            topButton.style.display = "none";
        }
    }
}

/**
 * Makes the page to move at the top
 */
const topFunction = () => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
}

const handleGoBack = (event) => {
    handleAutoSave(event);
    router.push({ name: 'dviworkorderpackages', params: { workordernumber: workordernumber.value, workorderid: workorderid.value } });
}

const handleAutoSave = () => {
    if (currentWorkOrderPackage !== undefined) {
        currentWorkOrderPackage[0].WorkOrderPackageInspectionLines = currentWorkOrderPackageInspectionLinesRef.value;
        store.commit(MutationTypes.UPDATE_DVIWOPACKAGE, { WorkOrderNumber: workordernumber.value, WorkOrderPackageID: workorderpackageid.value, WorkOrderPackage: currentWorkOrderPackage[0] });
    }
}//end of handleAutoSave

const selectRow = (WorkOrderPackageInspectionLineID, index: number) => {
    currentWorkOrderPackageInspectionLineID.value = WorkOrderPackageInspectionLineID;
    currentInspectionLineIndex.value = index;
    
    if (sortResult.value !== '') {
        const lastLineItem = InspectionLinesLength.value - currentWorkOrderPackageInspectionLinesRef.value.filter((item) => item.Type === 'Header').length;
        if (currentInspectionLineIndex.value == 0) {
            PreviousButtonDisableStatus.value = true;
            NextButtonDisableStatus.value = false;
        } else if (currentInspectionLineIndex.value == (lastLineItem - 1)) {
            PreviousButtonDisableStatus.value = false;
            NextButtonDisableStatus.value = true;
        } else {
            PreviousButtonDisableStatus.value = false;
            NextButtonDisableStatus.value = false;
        }
    }
    else if (currentInspectionLineIndex.value == 1 && currentWorkOrderPackageInspectionLinesRef.value[0].Type === 'Header') {
        PreviousButtonDisableStatus.value = true;
        NextButtonDisableStatus.value = false;
    } else if (index == 0) {
        PreviousButtonDisableStatus.value = true;
        NextButtonDisableStatus.value = false;
    } else if (index == (InspectionLinesLength.value - 1)) {
        PreviousButtonDisableStatus.value = false;
        NextButtonDisableStatus.value = true;
    } else {
        PreviousButtonDisableStatus.value = false;
        NextButtonDisableStatus.value = false;
    }
}

const processUnitandLFRFLRRR = () => {
    const currentItem = currentWorkOrderPackageInspectionLinesRef.value[currentInspectionLineIndex.value];

    if (currentItem.LF === '' && currentItem.LR === '' && currentItem.RF === '' && currentItem.RR === '' && currentItem.Unit === '' && currentItem.UnitText === '') {
        return true;
    }

    if (currentItem.Unit == "PSI")
        currentItem.UnitText = "psi";

    if (currentItem.Unit == "BAR")
        currentItem.UnitText = "bar";

    if (currentItem.Unit == "Millimeter")
        currentItem.UnitText = "mm";

    if (currentItem.Unit == "NDS")
        currentItem.UnitText = '/32"';

    LF.value = currentItem.LF;
    RF.value = currentItem.RF;
    LR.value = currentItem.LR;
    RR.value = currentItem.RR;

    if (currentItem.InputType != '' && (currentItem.LF === '' || currentItem.LR === '' || currentItem.RF === '' || currentItem.RR === '' || currentItem.Unit === '' || currentItem.UnitText === ''))
        return false;

    return true;
}

const closeSidebar = async () => {
    imageLoaded.value = [];
    if (!processUnitandLFRFLRRR() && !await v$.value.$validate())
        return toast.add({ severity: 'error', summary: 'Fail', detail: 'Please enter valid values.', life: 3000 });

    clearImages();
    clearVideos();

    handleAutoSave();

    showResultIcon.value = !currentWorkOrderPackageInspectionLinesRef.value
        .filter((item) => item.Type === 'Line')
        .every((item) => item.Result.trim() !== '');

    currentInspectionLineIndex.value = 10000;
    selectedInspectionNote.value = '';
}

const previous = async () => {
    imageLoaded.value = [];
    if (!processUnitandLFRFLRRR() && !await v$.value.$validate())
        return toast.add({ severity: 'error', summary: 'Fail', detail: 'Please enter valid values.', life: 3000 });

    clearImages();
    clearVideos();

    handleAutoSave();
    currentInspectionLineIndex.value = validateItemType(currentInspectionLineIndex.value - 1, 'previous');
    
    const currentItem = currentWorkOrderPackageInspectionLinesRef.value[currentInspectionLineIndex.value];
    currentWorkOrderPackageInspectionLineID.value = currentItem.WorkOrderPackageInspectionLineID;
    
    if (sortResult.value !== '') {
        if (currentInspectionLineIndex.value == 0) {
            PreviousButtonDisableStatus.value = true;
            NextButtonDisableStatus.value = false;
        } else {
            PreviousButtonDisableStatus.value = false;
            NextButtonDisableStatus.value = false;
        }
    }
    if (currentInspectionLineIndex.value == 1 && currentWorkOrderPackageInspectionLinesRef.value[0].Type === 'Header') {
        PreviousButtonDisableStatus.value = true;
        NextButtonDisableStatus.value = false;
    } else if (currentInspectionLineIndex.value == 0) {
        PreviousButtonDisableStatus.value = true;
        NextButtonDisableStatus.value = false;
    } else {
        PreviousButtonDisableStatus.value = false;
        NextButtonDisableStatus.value = false;
    }

    selectedInspectionNote.value = '';
}

const next = async () => {
    imageLoaded.value = [];
    if (!processUnitandLFRFLRRR() && !await v$.value.$validate())
        return toast.add({ severity: 'error', summary: 'Fail', detail: 'Please enter valid values.', life: 3000 });

    clearImages();
    clearVideos();
   
    handleAutoSave();
    currentInspectionLineIndex.value = validateItemType(currentInspectionLineIndex.value + 1, 'next');
    
    currentWorkOrderPackageInspectionLineID.value = currentWorkOrderPackageInspectionLinesRef.value[currentInspectionLineIndex.value].WorkOrderPackageInspectionLineID;
    if (sortResult.value !== '') {
        const lastLineItem = InspectionLinesLength.value - currentWorkOrderPackageInspectionLinesRef.value.filter((item) => item.Type === 'Header').length;
        if (currentInspectionLineIndex.value == (lastLineItem - 1)) {
            PreviousButtonDisableStatus.value = false;
            NextButtonDisableStatus.value = true;
        } else {
            PreviousButtonDisableStatus.value = false;
            NextButtonDisableStatus.value = false;
        }
    }
    else if (currentInspectionLineIndex.value == (InspectionLinesLength.value - 1)) {
        PreviousButtonDisableStatus.value = false;
        NextButtonDisableStatus.value = true;
    } else {
        PreviousButtonDisableStatus.value = false;
        NextButtonDisableStatus.value = false;
    }

    selectedInspectionNote.value = '';
}


/**
 * Apply to all ok status
 */
 const handleResultOK = () => {
    let BlankResultInspectionLines=currentWorkOrderPackageInspectionLinesRef.value.filter(obj => obj.Result == "")
    if (BlankResultInspectionLines != 0) {
        confirm.require({
            message: 'Do you want to set all remaining items to OK?',
            header: 'Please confirm action',
            icon: 'pi pi-exclamation-circle',
            acceptClass: 'p-button-primary',
                accept: async () => {
                currentWorkOrderPackageInspectionLinesRef.value.map(obj => {
                    if (obj.Result == '' && obj.Type == 'Line') {
                        obj.Result = 'OK';
                    }
                })
                if (currentWorkOrderPackage !== undefined) {
                    currentWorkOrderPackage[0].WorkOrderPackageInspectionLines.map(obj => {
                        if (obj.Result == "") {
                            obj.Result = 'OK';
                        }
                    })
                }
                handleAutoSave();
                showResultIcon.value = false;
                toast.add({ severity: 'success', summary: 'Set', detail: 'All remaining items have been set to OK', life: 3000 });
            },//end of accept
        }); //end of confirm
    }//end if
}

const imageServerOptions = {
    server: {
        // eslint-disable-next-line
        process: async (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
            
            // fieldName is the name of the input field
            // file is the actual file object to send
            
            const storeid = store.state.storeid;
            const filetype = file.type.split("/")[1];

            // get secure url from our server
            try {
                const accessToken = await auth0.getAccessTokenSilently();
                const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "s3/getpresignedputobjecturl/" + storeid + "/" + workordernumber.value + "/" + filetype, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });
                const data = await response.json();
                const { url } = data;
                if (response.status > 400) {
                    throw new Error(JSON.stringify(data.error));
                }
                const imageUrl = url.split('?')[0];
                const request = new XMLHttpRequest();
                request.open('PUT', url);

                // Should call the progress method to update the progress to 100% before calling load
                // Setting computable to false switches the loading indicator to infinite mode
                request.upload.onprogress = (e) => {
                    progress(e.lengthComputable, e.loaded, e.total);
                };

                // Should call the load method when done and pass the returned server file id
                // this server file id is then used later on when reverting or restoring a file
                // so your server knows which file to return without exposing that info to the client
                request.onload = function () {
                    if (request.status >= 200 && request.status < 300) {
                        // the load method accepts either a string (id) or an object
                        load(request.responseText);

                        //update/append InspectionLines ref
                        const latestInspectionLineMediaKeys = currentWorkOrderPackageInspectionLinesRef.value.filter(obj => obj.WorkOrderPackageInspectionLineID === currentWorkOrderPackageInspectionLineID.value)[0].MediaKeys.concat(imageUrl);
                        currentWorkOrderPackageInspectionLinesRef.value.filter(obj => obj.WorkOrderPackageInspectionLineID === currentWorkOrderPackageInspectionLineID.value)[0].MediaKeys = latestInspectionLineMediaKeys;

                        //update/append currentWorkOrderPackage in memory
                        if (currentWorkOrderPackage !== undefined) {
                            currentWorkOrderPackage[0].WorkOrderPackageInspectionLines.filter(obj => obj.WorkOrderPackageInspectionLineID === currentWorkOrderPackageInspectionLineID.value)[0].MediaKeys = latestInspectionLineMediaKeys;
                        }

                        //update VUEx media key state
                        store.commit(MutationTypes.UPDATE_MEDIAKEYS, { WorkOrderNumber: workordernumber.value, WorkOrderPackageID: workorderpackageid.value, WorkOrderPackageInspectionLineID: currentWorkOrderPackageInspectionLineID.value, MediaKeys: latestInspectionLineMediaKeys });
                        checkImageProgress();
                    } else {
                        // can call the error method if something is wrong, should exit after
                        error('error uploading image');
                    }
                };

                request.send(file);
                // Should expose an abort method so the request can be cancelled
                return {
                    abort: () => {
                        // This function is entered if the user has tapped the cancel button
                        request.abort();

                        // Let FilePond know the request has been cancelled
                        abort();
                    },
                };
            } catch (e) {
                openErrorModal(e.message);
            }
        },
    },//end of server
};

/**
 * Image file pond initialization
 */
const handleFilePondInit = () => {
    imagepond.value[0]._pond.setOptions(imageServerOptions);
}

const videoServerOptions = {
    server: {
        // eslint-disable-next-line
        process: async (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
            const accessToken = await auth0.getAccessTokenSilently();
            const formData = new FormData();
            try {
                const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + 'videos/token/' + store.state.storeid, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });
                const generatedToken = await response.json();
                if (response.status > 400) {
                    throw new Error(JSON.stringify(generatedToken.error));
                }
                formData.append('source_video', file, file.name);
                formData.append('folder_id', generatedToken.folder_id);
                formData.append('token', generatedToken.token);
            } catch (e) {
                openErrorModal(e.message);
            }

            try {
                const oReq = new XMLHttpRequest();
                oReq.open('POST', process.env.VUE_APP_SPROUTVIDEO_API_BASE_URL + "videos", true);
                oReq.upload.onprogress = (e) => {
                    progress(e.lengthComputable, e.loaded, e.total);
                }
                oReq.onreadystatechange = () => {
                    if (oReq.readyState === XMLHttpRequest.DONE) {
                        if (oReq.status === 201 || oReq.status === 200) {
                            const actualData = JSON.parse(oReq.response);
                            setVideoMediaKeys(actualData);
                            load();
                            checkVideoProgress();
                        } else {
                            abort();
                        }
                    }
                }
                oReq.send(formData);
            } catch (error) {
                // handle network error
                console.error("Error uploading video:", error);
            }
        }
    }
};

/**
 * Video file pond initialization
 */
const handleVideoPondInit = () => {
    videopond.value[0]._pond.setOptions(videoServerOptions);
}

// Create FilePond component
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileValidateSize, FilePondPluginImageTransform, FilePondPluginImageResize);

/**
 * Instantiation of VideoFilePond Component
 */
const VideoFilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilePondPluginMediaPreview);

/**
 * Before calling the processFiles function, verify whether the combined length of mediaKey and selectedImages is less than max count.
 * @param mediaKeys 
 */
const uploadImages = async (mediaKeys) => {
    if (getImageMedia(mediaKeys).length + selectedImages.value.length <= imageMaxCount) {
        imageUploadCount.value = selectedImages.value.length;
        imagepond.value[0].processFiles();
    } else {
        toast.add({ severity: 'error', summary: 'Image Upload', detail: `You can upload only ${imageMaxCount} image files.`, life: 3000 });
    }
}

/**
 * Verify first if imagepond instance exists then remove the files in selectedImages and in imagepond instance
 */
const clearImages = () => {
    if (imagepond.value !== null && imagepond.value.length !== 0) {
        const imagePondInstance = imagepond.value[0];
        imagePondInstance.removeFiles();
        selectedImages.value = [];
    }
}

/**
 * Before calling the processFiles function, verify whether the combined length of mediaKey and selectedVideos is less than max count.
 * @param mediaKeys 
 */
const uploadVideos = (mediaKeys) => {
    if (getVideoMedia(mediaKeys).length + selectedVideos.value.length <= videoMaxCount) {
        videoUploadCount.value = selectedVideos.value.length;
        videopond.value[0].processFiles();
    } else {
        toast.add({ severity: 'error', summary: 'Video Upload', detail: `You can upload only ${videoMaxCount} video files.`, life: 3000 });
    }
};

/**
 * Verify first if videopond instance exists then remove the files in selectedVideos and in videopond instance
 */
const clearVideos = () => {
    if (videopond.value !== null && videopond.value.length !== 0) {
        const videoPondInstance = videopond.value[0];
        videoPondInstance.removeFiles();
        selectedVideos.value = [];
    }
}

/**
 * Set video data in vuex
 * @param data 
 */
const setVideoMediaKeys = (data) => {
    const video = `https://api-files.sproutvideo.com/file/${data.id}/${data.security_token}/`;
    const thumbnail = data?.assets?.thumbnails[0];
    const videoMedia = `${thumbnail}|${video}`;

    //update/append InspectionLines ref
    const latestInspectionLineMediaKeys = currentWorkOrderPackageInspectionLinesRef.value.filter(obj => obj.WorkOrderPackageInspectionLineID === currentWorkOrderPackageInspectionLineID.value)[0].MediaKeys.concat(videoMedia);
    currentWorkOrderPackageInspectionLinesRef.value.filter(obj => obj.WorkOrderPackageInspectionLineID === currentWorkOrderPackageInspectionLineID.value)[0].MediaKeys = latestInspectionLineMediaKeys;

    //update/append currentWorkOrderPackage in memory
    if (currentWorkOrderPackage !== undefined) {
        currentWorkOrderPackage[0].WorkOrderPackageInspectionLines.filter(obj => obj.WorkOrderPackageInspectionLineID === currentWorkOrderPackageInspectionLineID.value)[0].MediaKeys = latestInspectionLineMediaKeys;
    }

    //update VUEx media key state
    //store has already been initiated 
    store.commit(MutationTypes.UPDATE_MEDIAKEYS, { WorkOrderNumber: workordernumber.value, WorkOrderPackageID: workorderpackageid.value, WorkOrderPackageInspectionLineID: currentWorkOrderPackageInspectionLineID.value, MediaKeys: latestInspectionLineMediaKeys });
}

/**
 * Verify first if error is null then include add file id.
 * @param error 
 * @param imageItem 
 */
const addImageFile = (error, imageItem) => {
    if (error === null) {
        selectedImages.value.push({ file_id: imageItem.id });
        const previewEl = document.querySelector(`#filepond--item-${imageItem.id}`);
        if (previewEl) {
            previewEl.addEventListener('click', () => {
                const img = new Image();
                img.src = URL.createObjectURL(imageItem.file);
                img.onload = () => {
                    const originalWidth = img.naturalWidth;
                    const originalHeight = img.naturalHeight;
                    URL.revokeObjectURL(img.src);
                    setImageAnnotation(originalWidth, originalHeight, imageItem);
                };
            });
        }
    }// end of error null
}

const setImageAnnotation = (originalWidth: number, originalHeight: number, imageItem) => {
    imageeditorvisible.value = true;
    const rawFile = imageItem.file; // native File object

    // Reserve space for toolbar/header if needed
    const toolbarHeight = 120;

    // Max canvas size inside viewport
    const maxWidth = window.innerWidth * 0.95;
    const maxHeight = window.innerHeight - toolbarHeight;

    // Fit the image fully inside available space (letterbox)
    const ratio = Math.min(maxWidth / originalWidth, maxHeight / originalHeight, 1);

    canvasWidth.value = Math.round(originalWidth * ratio);
    canvasHeight.value = Math.round(originalHeight * ratio);

    // Convert file to base64 and set as background
    const reader = new FileReader();
    reader.readAsDataURL(rawFile);
    reader.onload = () => {
        const base64 = reader.result as string;
        editor.value?.setBackgroundImage(base64);
    };
};

/**
 * Remove the image file.
 * @param error 
 * @param imageItem 
 */
const removeImageFile = (error, imageItem) => {
    selectedImages.value = selectedImages.value.filter((item) => item.file_id !== imageItem.id);
}

/**
 * Verify first if error is null then add the file id.
 * @param error 
 * @param videoItem 
 */
const addVideoFile = (error, videoItem) => {
    if (error === null) {
        selectedVideos.value.push({file_id: videoItem.id});
    }
}

/**
 * Remove the video file.
 * @param error 
 * @param videoItem 
 */
const removeVideoFile = (error, videoItem) => {
    selectedVideos.value = selectedVideos.value.filter((item) => item.file_id !== videoItem.id);
}

/**
 * Set the image src with the default no image.
 * @param event 
 * @param srcImg 
 */
const handleImageError = (event, srcImg) => {
    event.target.src = srcImg;
}

/**
 * Get actual image from media item value.
 * @param mediaItem 
 */
const getActualImage = (mediaItem) => {
    return mediaItem.split('|')[0];
}

/**
 * Get actual video from media item value.
 * @param mediaItem 
 */
const getActualVideo = (mediaItem) => {
    return mediaItem.split('|')[1];
}

/**
 * Adding a toast once done with the uploads.
 */
const checkImageProgress = () => {
    currentImageUploadCount.value++;
                    
    if (currentImageUploadCount.value === imageUploadCount.value) {
        toast.add({ severity: 'success', summary: 'Image Upload', detail: 'The image(s) have been successfully uploaded.', life: 3000 });
        currentImageUploadCount.value = 0;
        imageUploadCount.value = 0;
        clearImages();
    }
}

/**
 * Adding a toast once done with the uploads
 */
const checkVideoProgress = () => {
    currentVideoUploadCount.value++;
                    
    if (currentVideoUploadCount.value === videoUploadCount.value) {
        toast.add({ severity: 'success', summary: 'Video Upload', detail: 'The video(s) have been successfully uploaded.', life: 3000 });
        currentVideoUploadCount.value = 0;
        videoUploadCount.value = 0;
        clearVideos();
    }
}

/**
 * A function that returns boolean for the Images label to appear
 * @param mediaItems 
 */
const checkInspectionItemImages = (mediaItems) => {
    if (mediaItems.length !== 0) {
        return mediaItems.some((item: string) => !(item.includes("|")));
    }

    return false;
}

/**
 * A function that returns boolean for the Videos label to appear
 * @param mediaItems 
 */
const checkInspectionItemVideo = (mediaItems) => {
    if (mediaItems.length !== 0) {
        return mediaItems.some((item: string) => item.includes("|"));
    }

    return false;
}

/**
 * Get all image media in MediaKeys
 * @param mediaItems 
 */
const getImageMedia = (mediaItems) => {
    return mediaItems.filter((item: string) => !item.includes("|"));
}

/**
 * Get all video media in MediaKeys
 * @param mediaItems 
 */
const getVideoMedia = (mediaItems) => {
    return mediaItems.filter((item: string) => item.includes("|"));
}

/**
 * Handle on input event of subfield LF
 * @param event 
 */
const handleChangeInputLF = (event) => {
    LF.value = event.target.value;
    v$.value.LF.$validate();
}

/**
 * Handle on input event of subfield LR
 * @param event 
 */
const handleChangeInputLR = (event) => {
    LR.value = event.target.value;
    v$.value.LR.$validate();
}

/**
 * Handle on input event of subfield RF
 * @param event 
 */
const handleChangeInputRF = (event) => {
    RF.value = event.target.value;
    v$.value.RF.$validate();
}

/**
 * Handle on input event of subfield RR
 * @param event 
 */
const handleChangeInputRR = (event) => {
    RR.value = event.target.value;
    v$.value.RR.$validate();
}

/**
 * Delete actual
 * @param WorkOrderPackageInspectionLineID 
 * @param index 
 * @param media 
 */
const deleteVideo = async (WorkOrderPackageInspectionLineID: string, index: number, media: string) => {
    deleteVideoInVuex(index);
    //delete image from db through integration API
    await deleteVideoIntegrationAPI(WorkOrderPackageInspectionLineID, media);
    await deleteVideoInSproutAPI(media);
}

/**
 * Delete Video in integration API
 * @param WorkOrderPackageInspectionLineID 
 * @param media 
 */
const deleteVideoIntegrationAPI = async (WorkOrderPackageInspectionLineID: string, media: string) => {
    let mediadata = {
        MediaKey: media,
        Username:Username.value
    };

    const storeid = store.state.storeid;
    const url = process.env.VUE_APP_NODEJS_BASE_URL + "dviworkorders/s3mediakey/" + storeid + "/" + WorkOrderPackageInspectionLineID;

    try {
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(url, {
            method: 'PATCH',
            body: JSON.stringify(mediadata),
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
    } catch (e) {
        openErrorModal(e.message);
    }
}

/**
 * Delete video in vuex
 * @param WorkOrderPackageInspectionLineID 
 * @param index 
 */
const deleteVideoInVuex = (index: number) => {
    imageLoaded.value.splice(index, 1);
    //delete image from array ref memory
    const updatedMediaKeys = [...currentWorkOrderPackageInspectionLinesRef.value[currentInspectionLineIndex.value].MediaKeys];
    updatedMediaKeys.splice(index, 1);
    currentWorkOrderPackageInspectionLinesRef.value[currentInspectionLineIndex.value].MediaKeys = updatedMediaKeys;

    //delete image from VUEX state
    if (currentWorkOrderPackage !== undefined) {
        currentWorkOrderPackage[0].WorkOrderPackageInspectionLines = currentWorkOrderPackageInspectionLinesRef.value;
        store.commit(MutationTypes.UPDATE_DVIWOPACKAGE, { WorkOrderNumber: workordernumber.value, WorkOrderPackageID: workorderpackageid.value, WorkOrderPackage: currentWorkOrderPackage[0] });
    }
}

/**
 * Delete video in sprout API
 * @param videoID 
 */
const deleteVideoInSproutAPI = async (media: string) => {
    const videoUrl = getActualVideo(media);
    
    // get video id using video url
    const videoArray = videoUrl.split('/');
    const videoID = videoArray[videoArray.length - 3];

    try {
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + 'videos/' + videoID, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });

        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
    } catch (e) {
        openErrorModal(e.message);
    }
}

/**
 * Delete actual image
 * @param WorkOrderPackageInspectionLineID 
 * @param Imageindex 
 * @param ImageFullUrl 
 */
const deleteImage = async (WorkOrderPackageInspectionLineID, index: number, ImageFullUrl) => {
    deleteImageInVuex(index);
    //delete image from db through integration API
    await deleteImageIntegrationAPI(WorkOrderPackageInspectionLineID, ImageFullUrl);
    await deleteImageInAWSS3(ImageFullUrl);
}

/**
 * Delete image in vuex
 * @param ImageFullUrl 
 */
const deleteImageInVuex = (index: number) => {
    imageLoaded.value.splice(index, 1);
    //delete image from array ref memory
    const updatedMediaKeys = [...currentWorkOrderPackageInspectionLinesRef.value[currentInspectionLineIndex.value].MediaKeys];
    updatedMediaKeys.splice(index, 1);
    currentWorkOrderPackageInspectionLinesRef.value[currentInspectionLineIndex.value].MediaKeys = updatedMediaKeys;

    //delete image from VUEX state
    if (currentWorkOrderPackage !== undefined) {
        currentWorkOrderPackage[0].WorkOrderPackageInspectionLines = currentWorkOrderPackageInspectionLinesRef.value;
        store.commit(MutationTypes.UPDATE_DVIWOPACKAGE, { WorkOrderNumber: workordernumber.value, WorkOrderPackageID: workorderpackageid.value, WorkOrderPackage: currentWorkOrderPackage[0] });
    }
}

/**
 * Delete image in API server
 * @param WorkOrderPackageInspectionLineID 
 * @param ImageFullUrl 
 */
const deleteImageIntegrationAPI = async (WorkOrderPackageInspectionLineID: string, ImageFullUrl: string) => {
    let mediadata = {
        MediaKey: ImageFullUrl,
        Username: Username.value
    };

    const storeid = store.state.storeid;
    const url = process.env.VUE_APP_NODEJS_BASE_URL + "dviworkorders/s3mediakey/" + storeid + "/" + WorkOrderPackageInspectionLineID;

    try {
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(url, {
            method: 'PATCH',
            body: JSON.stringify(mediadata),
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
    } catch (e) {
        openErrorModal(e.message);
    }
}

/**
 * Delete image in AWS S3
 * @param ImageFullUrl 
 */
const deleteImageInAWSS3 = async (ImageFullUrl: string) => {
    const storeid = store.state.storeid;
    const deletedMediaKey = ImageFullUrl.split("/")[5];
    const s3url = process.env.VUE_APP_NODEJS_BASE_URL + "s3/deleteobject/" + storeid + "/"  + workordernumber.value + "/" + deletedMediaKey;
    try {
        const accessToken = await auth0.getAccessTokenSilently();
        const response = await fetch(s3url, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();
        if (response.status > 400) {
            throw new Error(JSON.stringify(data.error));
        }
    } catch (e) {
        openErrorModal(e.message);
    }
}

/**
 * Returns if mediaValue is video or not
 * @param mediaValue 
 */
const isVideo = (mediaValue: string) => {
    return mediaValue.includes("|");
}

/**
 * Set index with true value once the image is loaded
 * @param index 
 */
const setLoaded = (index) => {
  imageLoaded.value[index] = true;
}

/**
 * Go to Summary page
 */
const gotoSummary = () => {
    router.push({ name: 'dvisummaryworkorderpackage', params: { workorderpackageid: workorderpackageid.value, workorderpackageheader: workorderpackageheader.value }  });
}

/**
 * Apply click event only for inspection items with type line
 * @param InspectionLine 
 * @param index 
 */
const handleRowClick = (InspectionLine, index: number) => {
    if (InspectionLine.Type === 'Line') {
        selectRow(InspectionLine.WorkOrderPackageInspectionLineID, index);
    }
}

/**
 * Validate if the item type is header or line
 * @param newIndex 
 * @param action 
 */
const validateItemType = (newIndex: number, action: string) => {
    const futureItem = currentWorkOrderPackageInspectionLinesRef.value[newIndex];
    if (futureItem.Type === 'Header') {
        if (action === 'next') {
            return newIndex + 1;
        }

        if (action === 'previous') {
            return newIndex - 1;
        }
    }

    return newIndex;
}

/**
 * Changes the sorting value if the user clicks on the result sorting icon
 */
const handleSorting = () => {
    switch(sortResult.value) {
        case '': sortResult.value = 'asc'
            break;
        case 'asc': sortResult.value = 'desc'
            break;
        case 'desc': sortResult.value = ''
            break;
    }
}

/**
 * Put the item on the last if the type is header
 * desc, required is the highest
 * asc, required is the lowest
 * @param a 
 * @param b 
 */
const customSort = (a, b) => {
    let order = { Required: 1, Suggested: 2, OK: 3, '': 4 };
    if (sortResult.value === 'desc') {
        order = { Required: 4, Suggested: 3, OK: 2, '': 1 };
    }
    if (a.Type === 'Header') return 1;
    if (b.Type === 'Header') return -1;
    return order[a.Result] - order[b.Result];
};

/**
 * Return original sorting which is by Rank
 * Rank is the property which considered as index in API response
 * @param a 
 * @param b 
 */
const originalSorting = (a, b) => {
    return a.Rank - b.Rank; 
}

/**
 * Sort data original, custom ascending and descending
 * @param data 
 */
const sortData = (data) => {
    if(!data)
        return [];
    if (data && sortResult.value === '')
        return data.sort(originalSorting);
    return data.sort(customSort);
}

const handleChangeInspectionNote = (notes, selectedInspectionNote) => {
    if (selectedInspectionNote === '' || selectedInspectionNote === null) {
        return notes;
    }
    if (notes === '' || notes === null) {
        return selectedInspectionNote;
    }
    return notes += ` ${selectedInspectionNote}`;
}

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Listbox = _resolveComponent("Listbox")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorModal),
    _createVNode(_component_Toast),
    _createVNode(_component_ConfirmDialog),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(workorderpackageheader)), 1)
      ]),
      (!empty.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Button, {
              onClick: gotoSummary,
              label: "Review Inspection",
              class: "p-button-rounded btn-primary sml blocked"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleGoBack($event))),
          class: "p-button p-component p-button-rounded btn-primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Workorder " + _toDisplayString(workordernumber.value), 1)
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_7, [
          _createElementVNode("span", null, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(firstname.value) + " " + _toDisplayString(lastname.value), 1)
          ]),
          _createElementVNode("span", null, [
            _hoisted_9,
            _createTextVNode(" " + _toDisplayString(color.value) + " " + _toDisplayString(make.value) + " " + _toDisplayString(model.value), 1)
          ]),
          _createElementVNode("span", null, [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(plate.value), 1)
          ]),
          _createElementVNode("span", null, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_unref(UsageComputed)), 1)
          ])
        ])
      ]),
      (!empty.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  onClick: handleSorting,
                  class: "result"
                }, [
                  _createElementVNode("strong", {
                    style: _normalizeStyle({color: sortResult.value != '' ? '#2196F3' : ''})
                  }, "Result", 4),
                  _createElementVNode("span", {
                    style: _normalizeStyle({color: sortResult.value != '' ? '#2196F3' : ''})
                  }, [
                    (sortResult.value === '')
                      ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                      : _createCommentVNode("", true),
                    (sortResult.value === 'asc')
                      ? (_openBlock(), _createElementBlock("i", _hoisted_17))
                      : _createCommentVNode("", true),
                    (sortResult.value === 'desc')
                      ? (_openBlock(), _createElementBlock("i", _hoisted_18))
                      : _createCommentVNode("", true)
                  ], 4)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("span", {
                    onClick: handleResultOK,
                    style: {"cursor":"pointer"},
                    class: "customer-badge status-null"
                  }, "Set Ok", 512), [
                    [_vShow, showResultIcon.value]
                  ])
                ])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortData(currentWorkOrderPackageInspectionLinesRef.value), (InspectionLine, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "inspection-item",
                onClick: ($event: any) => (handleRowClick(InspectionLine, index)),
                style: _normalizeStyle({ display: (InspectionLine.Type === 'Header' && sortResult.value !== '') ? 'none' : '' })
              }, [
                (InspectionLine.Type === 'Header' && sortResult.value === '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("strong", null, _toDisplayString(InspectionLine.Title), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (InspectionLine.Type === 'Line')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createTextVNode(_toDisplayString(InspectionLine.Title) + " ", 1),
                        (InspectionLine?.Notes?.length || InspectionLine?.ShopNotes?.length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Notes"))
                          : _createCommentVNode("", true),
                        (checkInspectionItemImages(InspectionLine.MediaKeys))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Images"))
                          : _createCommentVNode("", true),
                        (checkInspectionItemVideo(InspectionLine.MediaKeys))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Videos"))
                          : _createCommentVNode("", true)
                      ]),
                      (InspectionLine.Result)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _createElementVNode("span", {
                              class: _normalizeClass('customer-badge status-' + InspectionLine.Result)
                            }, _toDisplayString(InspectionLine.Result), 3)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31)),
                      _hoisted_32
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Sidebar, {
                  visible: currentInspectionLineIndex.value == index,
                  "block-scroll": false,
                  baseZIndex: 10000,
                  showCloseIcon: false,
                  position: "right"
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_Button, {
                        onClick: closeSidebar,
                        class: "p-sidebar-icon p-link"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_34
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_Button, {
                        label: "Previous",
                        class: "p-button-rounded btn-secondary sml",
                        onClick: previous,
                        disabled: PreviousButtonDisableStatus.value
                      }, null, 8, ["disabled"]),
                      _createVNode(_component_Button, {
                        label: "Next",
                        class: "p-button-rounded btn-secondary sml",
                        onClick: next,
                        disabled: NextButtonDisableStatus.value
                      }, null, 8, ["disabled"])
                    ]),
                    _createElementVNode("h3", null, _toDisplayString(InspectionLine.Title), 1),
                    _createElementVNode("div", null, [
                      _createVNode(_component_SelectButton, {
                        onChange: () => {
                            InspectionLine.Comment = '';
                            InspectionLine.Result = InspectionLine.Result === null ? '' : InspectionLine.Result;
                        },
                        modelValue: InspectionLine.Result,
                        "onUpdate:modelValue": ($event: any) => ((InspectionLine.Result) = $event),
                        options: status.value,
                        class: "select-status"
                      }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "options"]),
                      (InspectionLine.InputType != '')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_36, _hoisted_38))
                        : _createCommentVNode("", true),
                      (InspectionLine.InputType != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("span", _hoisted_40, [
                              _createElementVNode("span", null, [
                                _hoisted_41,
                                _createVNode(_component_InputText, {
                                  id: "LF",
                                  modelValue: InspectionLine.LF,
                                  "onUpdate:modelValue": ($event: any) => ((InspectionLine.LF) = $event),
                                  class: _normalizeClass({error: _unref(v$).LF.$error}),
                                  onInput: _cache[1] || (_cache[1] = (event) => handleChangeInputLF(event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                                (_unref(v$).LF.$error)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_unref(v$).LF.$errors[0].$message), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("span", null, [
                                _hoisted_43,
                                _createVNode(_component_InputText, {
                                  id: "RF",
                                  modelValue: InspectionLine.RF,
                                  "onUpdate:modelValue": ($event: any) => ((InspectionLine.RF) = $event),
                                  class: _normalizeClass({error: _unref(v$).RF.$error}),
                                  onInput: _cache[2] || (_cache[2] = (event) => handleChangeInputRF(event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                                (_unref(v$).RF.$error)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_unref(v$).RF.$errors[0].$message), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("span", _hoisted_45, [
                              _createElementVNode("p", null, [
                                _hoisted_46,
                                (InspectionLine.InputType == 'TirePressure')
                                  ? (_openBlock(), _createBlock(_unref(Dropdown), {
                                      key: 0,
                                      modelValue: InspectionLine.Unit,
                                      "onUpdate:modelValue": ($event: any) => ((InspectionLine.Unit) = $event),
                                      options: unit1.value,
                                      optionLabel: "UnitText",
                                      optionValue: "Unit"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                  : (_openBlock(), _createBlock(_unref(Dropdown), {
                                      key: 1,
                                      modelValue: InspectionLine.Unit,
                                      "onUpdate:modelValue": ($event: any) => ((InspectionLine.Unit) = $event),
                                      options: unit2.value,
                                      optionLabel: "UnitText",
                                      optionValue: "Unit"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                              ])
                            ]),
                            _createElementVNode("span", _hoisted_47, [
                              _createElementVNode("span", null, [
                                _hoisted_48,
                                _createVNode(_component_InputText, {
                                  id: "LR",
                                  modelValue: InspectionLine.LR,
                                  "onUpdate:modelValue": ($event: any) => ((InspectionLine.LR) = $event),
                                  class: _normalizeClass({error: _unref(v$).LR.$error}),
                                  onInput: _cache[3] || (_cache[3] = (event) => handleChangeInputLR(event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                                (_unref(v$).LR.$error)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(_unref(v$).LR.$errors[0].$message), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("span", null, [
                                _hoisted_50,
                                _createVNode(_component_InputText, {
                                  id: "RR",
                                  modelValue: InspectionLine.RR,
                                  "onUpdate:modelValue": ($event: any) => ((InspectionLine.RR) = $event),
                                  class: _normalizeClass({error: _unref(v$).RR.$error}),
                                  onInput: _cache[4] || (_cache[4] = (event) => handleChangeInputRR(event))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "class"]),
                                (_unref(v$).RR.$error)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(_unref(v$).RR.$errors[0].$message), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (InspectionLine.Result == 'Suggested')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_52, _hoisted_54))
                        : _createCommentVNode("", true),
                      (InspectionLine.Result == 'Suggested')
                        ? (_openBlock(), _createBlock(_component_Listbox, {
                            key: 3,
                            id: "listBoxSuggested",
                            modelValue: InspectionLine.Comment,
                            "onUpdate:modelValue": ($event: any) => ((InspectionLine.Comment) = $event),
                            options: suggestItem.value
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        : _createCommentVNode("", true),
                      (InspectionLine.Result == 'Required')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_55, _hoisted_57))
                        : _createCommentVNode("", true),
                      (InspectionLine.Result == 'Required')
                        ? (_openBlock(), _createBlock(_component_Listbox, {
                            key: 5,
                            id: "listBoxRequired",
                            modelValue: InspectionLine.Comment,
                            "onUpdate:modelValue": ($event: any) => ((InspectionLine.Comment) = $event),
                            options: RequiredItem.value
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        : _createCommentVNode("", true),
                      _hoisted_58,
                      (inspectionnotes.value.length != 0)
                        ? (_openBlock(), _createBlock(_unref(Dropdown), {
                            key: 6,
                            modelValue: selectedInspectionNote.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedInspectionNote).value = $event)),
                            filter: "",
                            options: inspectionnotes.value,
                            optionLabel: "Note",
                            optionValue: "Note",
                            style: {"width":"100%"},
                            id: "inspectionnotes",
                            placeholder: noteplaceholder.value,
                            onChange: ($event: any) => (InspectionLine.Notes = handleChangeInspectionNote(InspectionLine.Notes, selectedInspectionNote.value))
                          }, null, 8, ["modelValue", "options", "placeholder", "onChange"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_Textarea, {
                        modelValue: InspectionLine.Notes,
                        "onUpdate:modelValue": ($event: any) => ((InspectionLine.Notes) = $event),
                        rows: "3",
                        cols: "50",
                        maxlength: "500",
                        style: {"margin-top":"1rem"}
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("p", _hoisted_59, _toDisplayString(InspectionLine?.Notes?.length) + "/500", 1),
                      _hoisted_60,
                      _createVNode(_component_Textarea, {
                        modelValue: InspectionLine.ShopNotes,
                        "onUpdate:modelValue": ($event: any) => ((InspectionLine.ShopNotes) = $event),
                        rows: "3",
                        cols: "50",
                        maxlength: "500"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("p", _hoisted_61, _toDisplayString(InspectionLine?.ShopNotes?.length) + "/500", 1)
                    ]),
                    (checkInspectionItemImages(InspectionLine.MediaKeys))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_62,
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("ul", _hoisted_64, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(InspectionLine.MediaKeys, (mediaSrc, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: 'imageMedia-' + index,
                                  style: _normalizeStyle({
                                        display: !isVideo(mediaSrc) ? 'inline-block' : 'none',
                                        maxWidth:'calc(100% / 4)',
                                        paddingRight: '0.5rem',
                                        position: 'relative'
                                    })
                                }, [
                                  (!isVideo(mediaSrc))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _withDirectives((_openBlock(), _createElementBlock("img", {
                                          onLoad: ($event: any) => (setLoaded(index)),
                                          key: 'imgMedia-' + index,
                                          style: {"max-width":"100%"},
                                          alt: "Image",
                                          onError: _cache[6] || (_cache[6] = event => handleImageError(event, '/default_no_image.png'))
                                        }, null, 40, _hoisted_65)), [
                                          [_directive_lazy, mediaSrc]
                                        ]),
                                        _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                          key: 'btnImg-' + index,
                                          class: "p-button p-button-rounded btn-danger sml delete",
                                          style: {"position":"absolute","top":"0","right":"0"},
                                          onClick: ($event: any) => (deleteImage(InspectionLine.WorkOrderPackageInspectionLineID, index, mediaSrc))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_66
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])), [
                                          [_vShow, imageLoaded.value[index]]
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 4))
                              }), 128))
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    (checkInspectionItemVideo(InspectionLine.MediaKeys))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_67,
                          _createElementVNode("div", _hoisted_68, [
                            _createElementVNode("ul", _hoisted_69, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(InspectionLine.MediaKeys, (mediaSrc, index) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: 'videoMedia-' + index,
                                  style: _normalizeStyle({
                                        display: isVideo(mediaSrc) ? 'inline-block' : 'none',
                                        maxWidth:'calc(100% / 4)',
                                        paddingRight: '0.5rem',
                                        position: 'relative'
                                    })
                                }, [
                                  (isVideo(mediaSrc))
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _withDirectives((_openBlock(), _createElementBlock("img", {
                                          onLoad: ($event: any) => (setLoaded(index)),
                                          key: 'vidMedia-' + index,
                                          style: {"max-width":"100%"},
                                          alt: "Image",
                                          onError: _cache[7] || (_cache[7] = event => handleImageError(event, '/default_no_image.png'))
                                        }, null, 40, _hoisted_70)), [
                                          [_directive_lazy, getActualImage(mediaSrc)]
                                        ]),
                                        _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                          key: 'btnVid-' + index,
                                          class: "p-button p-button-rounded btn-danger sml delete",
                                          style: {"position":"absolute","top":"0","right":"0"},
                                          onClick: ($event: any) => (deleteVideo(InspectionLine.WorkOrderPackageInspectionLineID, index, mediaSrc))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_71
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])), [
                                          [_vShow, imageLoaded.value[index]]
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 4))
                              }), 128))
                            ])
                          ])
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_72, [
                      _hoisted_73,
                      (androidInfo.value.isAndroid && androidInfo.value.version > 13)
                        ? (_openBlock(), _createBlock(_component_ToggleButton, {
                            key: 0,
                            modelValue: isCaptureOn.value,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((isCaptureOn).value = $event)),
                            onLabel: "Use CAMERA",
                            offLabel: "Use GALLERY"
                          }, null, 8, ["modelValue"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_TabView, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_TabPanel, { header: "Images" }, {
                          default: _withCtx(() => [
                            (getImageMedia(InspectionLine.MediaKeys).length == _unref(imageMaxCount))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_74, _hoisted_76))
                              : (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                  _createVNode(_unref(FilePond), {
                                    name: "myfilepond",
                                    ref_for: true,
                                    ref_key: "imagepond",
                                    ref: imagepond,
                                    "class-name": "filepond",
                                    "label-idle": `Capture / Select Images to Upload (Max of ${_unref(imageMaxCount)} at < 5MB each)...`,
                                    "allow-multiple": "true",
                                    "accepted-file-types": "image/*",
                                    maxFiles: _unref(imageMaxCount),
                                    maxFileSize: "5MB",
                                    instantUpload: "false",
                                    maxParallelUploads: _unref(imageMaxCount),
                                    "allow-Remove": "true",
                                    "allow-Process": "false",
                                    "allow-Revert": "false",
                                    imageCropAspectRatio: "1:1",
                                    allowImageResize: "true",
                                    imageResizeTargetWidth: "null",
                                    imageResizeTargetHeight: "null",
                                    imageResizeMode: "contain",
                                    imageResizeUpscale: "false",
                                    onInit: handleFilePondInit,
                                    onAddfile: addImageFile,
                                    onRemovefile: removeImageFile
                                  }, null, 8, ["label-idle", "maxFiles", "maxParallelUploads"]),
                                  _createElementVNode("div", _hoisted_78, [
                                    _createVNode(_component_Button, {
                                      type: "button",
                                      disabled: !(selectedImages.value.length > 0),
                                      onClick: ($event: any) => (uploadImages(InspectionLine.MediaKeys))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_79,
                                        _hoisted_80
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"]),
                                    _createVNode(_component_Button, {
                                      type: "button",
                                      disabled: !(selectedImages.value.length > 0),
                                      onClick: clearImages
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_81,
                                        _hoisted_82
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ])
                                ]))
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_TabPanel, { header: "Video" }, {
                          default: _withCtx(() => [
                            (getVideoMedia(InspectionLine.MediaKeys).length == _unref(videoMaxCount))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_83, _hoisted_85))
                              : (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                  _createVNode(_unref(VideoFilePond), {
                                    name: "video",
                                    ref_for: true,
                                    ref_key: "videopond",
                                    ref: videopond,
                                    "class-name": "filepond",
                                    "label-idle": `Capture / Select Videos to Upload (Max of ${_unref(videoMaxCount)} at < 10MB each)...`,
                                    "allow-multiple": "true",
                                    "accepted-file-types": "video/*",
                                    maxFiles: _unref(videoMaxCount),
                                    maxFileSize: "10MB",
                                    instantUpload: "false",
                                    maxParallelUploads: _unref(videoMaxCount),
                                    "allow-Remove": "true",
                                    "allow-Process": "false",
                                    "allow-Revert": "false",
                                    onInit: handleVideoPondInit,
                                    onAddfile: addVideoFile,
                                    onRemovefile: removeVideoFile
                                  }, null, 8, ["label-idle", "maxFiles", "maxParallelUploads"]),
                                  _createElementVNode("div", _hoisted_87, [
                                    _createVNode(_component_Button, {
                                      type: "button",
                                      disabled: !(selectedVideos.value.length > 0),
                                      onClick: ($event: any) => (uploadVideos(InspectionLine.MediaKeys))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_88,
                                        _hoisted_89
                                      ]),
                                      _: 2
                                    }, 1032, ["disabled", "onClick"]),
                                    _createVNode(_component_Button, {
                                      type: "button",
                                      disabled: !(selectedVideos.value.length > 0),
                                      onClick: clearVideos
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_90,
                                        _hoisted_91
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ])
                                ]))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_92, [
                      _createVNode(_component_Button, {
                        label: "Close",
                        class: "p-button p-component p-button-rounded btn-secondary",
                        onClick: closeSidebar
                      })
                    ])
                  ]),
                  _: 2
                }, 1032, ["visible"])
              ], 12, _hoisted_20))
            }), 128)),
            (imageeditorvisible.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("div", _hoisted_96, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colors, (color) => {
                          return _createElementVNode("button", {
                            key: color,
                            style: _normalizeStyle({ backgroundColor: color }),
                            class: _normalizeClass({ active: selectedColor.value === color }),
                            onClick: ($event: any) => (updateColor(color))
                          }, null, 14, _hoisted_97)
                        }), 64))
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("span", _hoisted_99, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(edittools, (etool) => {
                            return _createElementVNode("div", {
                              key: etool.name,
                              class: _normalizeClass(["tool-icon", { active: selectedTool.value === etool.name }]),
                              onClick: ($event: any) => (selectTool(etool.name, etool.action))
                            }, [
                              _createVNode(_unref(VueFeather), {
                                type: etool.icon
                              }, null, 8, ["type"])
                            ], 10, _hoisted_100)
                          }), 64))
                        ]),
                        _createElementVNode("span", _hoisted_101, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(managetools, (mtool) => {
                            return _createElementVNode("div", {
                              key: mtool.name,
                              class: _normalizeClass(["tool-icon", { active: selectedTool.value === mtool.name }]),
                              onClick: ($event: any) => (selectTool(mtool.name, mtool.action))
                            }, [
                              _createVNode(_unref(VueFeather), {
                                type: mtool.icon
                              }, null, 8, ["type"])
                            ], 10, _hoisted_102)
                          }), 64))
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_103, [
                    _createVNode(_unref(Editor), {
                      canvasWidth: canvasWidth.value,
                      canvasHeight: canvasHeight.value,
                      ref_key: "editor",
                      ref: editor
                    }, null, 8, ["canvasWidth", "canvasHeight"])
                  ]),
                  _createElementVNode("div", {
                    class: "overlay-close",
                    onClick: closeImageAnnotation
                  }, "✕")
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (empty.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_104, "No inspection items found."))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        onClick: topFunction,
        id: "topBtn",
        icon: "pi pi-arrow-up",
        class: "btn-primary p-button-rounded",
        "aria-label": "Go to Top"
      })
    ])
  ], 64))
}
}

})